import { PuzzleConfig } from './types';

export const PUZZLE_CONFIGS: PuzzleConfig[] = [
  { name: 'Triword', dataKey: 'triword', color: '#8884d8' },
  { name: 'Pathword', dataKey: 'pathword', color: '#82ca9d' },
  { name: 'Arithmeglyphs', dataKey: 'arithmeglyphs', color: '#ffc658' },
  { name: 'Morphology', dataKey: 'morphology', color: '#ff7c7c' },
  { name: 'Rubigram', dataKey: 'rubigram', color: '#a28bfe' },
  { name: 'Megarubigram', dataKey: 'megarubigram', color: '#6dd5ed' },
  { name: 'Pathword 5x5', dataKey: 'pathword5x5', color: '#ff6b9d' },
  { name: 'Truthsorting', dataKey: 'truthsorting', color: '#ffa07a' },
];
